import { SessionVisibility } from "@swiggy-private/checkout-core";
import { LOCAL_STORAGE_KEYS } from "@swiggy-private/core-ui";

export const getAmazonPayDelinkedMessageFreqCappPayload = () => {
    return {
        id: "AMAZON_PAY_DELINKED_MESSAGE_FREQUENCY_CAPPING_ID",
        key: `${LOCAL_STORAGE_KEYS.AMAZON_PAY_DELINKED_MESSAGE_FREQUENCY_CAPPING_KEY}`,
        sessionVisibility: SessionVisibility.ONCE_PER_SESSION,
        maxFrequency: 1,
        sessionId: "CONSTANT", // To show only once
    };
};
